import React, { useState, useEffect } from 'react';
import Home from './home/Home';
import Game from './game/Game';
import LeftGame from './gameover/LeftGame';
import OutOfMoney from './gameover/OutOfMoney';

// Firebase
import {v4 as uuidv4} from 'uuid'; // For ids
import firebase from './firebase';

function App() {
  // Keep track of which stage in the game the user is at
  const [stage, setStage] = useState('home');

  // Keep track of leaderboard
  const [leaderboard, setLeaderboard] = useState(null);

  // Keep track of user's name
  const [name, setName] = useState('');

  // Keep track of user's money
  const [money, setMoney] = useState(100);

  useEffect(() => {
    if (!leaderboard) {
      // Connect to realtime database & reference leaderboards
      const ref = firebase.database().ref('leaderboard');
      // Get the leaderboard and set it to leaderboard state
      ref.on('value', (snapshot) => {
        let leaders = snapshot.val();
        let temp = [];
        for (let leader in leaders) {
           temp.push({
              id: uuidv4(),
              name: leader,
              money: leaders[leader]
            });
        }
        temp.sort((a, b) => (a.money < b.money) ? 1 : -1);
        setLeaderboard(temp);
      });
    }
    console.log(leaderboard);
  }, [leaderboard]);

  return (
    <>
      {(stage === 'home') &&
        <Home
          setStage={setStage}
          leaderboard={leaderboard}
          name={name}
          setName={setName}
        />
      }
      {(stage === 'game') &&
        <Game
          setStage={setStage}
          setLeaderboard={setLeaderboard}
          money={money}
          setMoney={setMoney}
          name={name}
        />
      }
      {(stage === 'leavegame') &&
        <LeftGame
          setStage={setStage}
          leaderboard={leaderboard}
          money={money}
          setMoney={setMoney}
          name={name}
        />
      }
      {(stage === 'gameover') &&
        <OutOfMoney
          setStage={setStage}
          leaderboard={leaderboard}
          setMoney={setMoney}
        />
      }
    </>
  );
}

export default App;
